// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3SE4h","noInteraction":"EventWrapper_noInteraction__KevsI"};